<template>
  <div class="share-desgin"
       @click="toShareTheme">
    <a-badge>
      <ExportOutlined class="cart-icon" />
      {{ $t('DesignShare.ShareDesgin.shareDesign') }}
    </a-badge>
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router"
const router = useRouter()
const route = useRoute()
const toShareTheme = () => {
  if (route.path != '/console/products/design_share' || route.query.themeId)
    router.push(`/console/products/design_share`)
  setTimeout(() => {
    location.reload()
  }, 0)
}
</script>

<style scoped lang="less">
.share-desgin {
  color: white;
  cursor: pointer;
  height: 0;
  margin: 2px 18px 0 0;

  :deep(.ant-badge) {
    font-family: 'Microsoft YaHei';
    font-size: 14px;
    color: white;
  }

  .cart-icon {
    font-size: 15px;
  }
}
</style>
